import React from 'react';
import { BadgeContainer } from './styles';

export const StatusBadge = ({ icon, color, backgroundColor, text }) => {
  return (
    <BadgeContainer color={color} backgroundColor={backgroundColor}>
      <i className="material-icons" style={{ fontSize: '12px', color }}>
        {icon}
      </i>
      <span>{text}</span>
    </BadgeContainer>
  );
};
